import { VenueReview } from "common/types";
import React from "react";
import BusinessReview from "./BusinessReview";

type BusinessReviewsProps = {
  reviews: VenueReview[];
  fullSize?: boolean;
  onFlag: (review: any) => void;
};

function BusinessReviews({ onFlag, reviews }: BusinessReviewsProps) {
  // get first 3 reviews
  return reviews.map((review, index) => (
    <BusinessReview key={index} review={review} onFlag={onFlag} />
  ));
}

export default BusinessReviews;
